import type { App } from 'vue';
import type { AxiosInstance } from 'axios';

import { featureFlag, FlagSource } from './instance';

declare module 'vue' {
  interface ComponentCustomProperties {
    $featureFlags: typeof featureFlag;
  }
}

export interface FeatureFlagPluginOptions {
  source: FlagSource;
  httpAdapter?: AxiosInstance;
}

export function install(options: FeatureFlagPluginOptions) {
  return (_app: App) => {
    if (options.httpAdapter) {
      featureFlag.setHttpAdapter(options.httpAdapter);
    }

    featureFlag.load(options.source);
  };
}

export { featureFlag };
export * from './instance';
export * from './useFeatureFlag';
